<ng-container *transloco="let t">
    <form [formGroup]="form" (ngSubmit)="submitForm()">
        <div class="form-group">
            <label for="prompt">
                {{ t("Prompt label (from scratch template) - Prompt") }}
                <span class="text-danger">*</span>
            </label>
            <div class="form-group">
                <textarea
                    formControlName="prompt"
                    type="text"
                    [placeholder]="
                        t(
                            'Prompt placeholder (from scratch template) - prompt placeholder'
                        )
                    "
                    class="form-control"
                    [class.is-invalid]="isPromptInvalid"
                    (blur)="onPromptBlur()"
                    rows="7"
                ></textarea>
                <!-- Error message display -->
                <div *ngIf="isPromptInvalid" class="invalid-feedback">
                    {{ promptErrorMessage }}
                </div>
                <!-- Helper text -->
                <small class="form-text text-muted">
                    {{
                        t(
                            "Prompt helper text (from scratch template) - Describe what kind of template you want to generate"
                        )
                    }}
                </small>
            </div>
        </div>
    </form>
</ng-container>
